import classNames from 'classnames';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import variables from '../theme/variables';

const useStyles = createUseStyles(
    {
        wrap: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },

        splashTitle: {
            color: variables.palette.white,
            fontFamily: variables.typography.gtAmerica,
            textTransform: 'uppercase',
            fontSize: 'min(10.8vw, 150px)',
            lineHeight: '0.8em',
            letterSpacing: '-0.05em',
            textAlign: 'center',

            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) scaleY(1.2)',

            display: 'flex',
            flexDirection: 'column',
        },

        letter: {
            position: 'relative',
        },

        letterFill: {
            transition: 'opacity 2s ease-out',
        },

        letterOutline: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            color: 'transparent',
            '-webkit-text-fill-color': 'transparent',
            '-webkit-text-stroke-width': '1px',
            '-webkit-text-stroke-color': 'white',

            transition: 'opacity 1.9s ease-out',
        },

        titleTop: {
            display: 'inline-block',
            transition: 'all 3s ease-out',
            whiteSpace: 'nowrap',
            transform: 'translateY(-30px)',
            opacity: 1,

            '&$out': {
                transitionDuration: '0.5s',
                transitionDelay: 0,
                transform: 'translateY(-100px)',
                opacity: 0,
            },

            '&$in': {
                transform: 'translateY(0px)',
            },
        },

        titleBottom: {
            display: 'inline-block',
            transition: 'all 3s ease-out',
            whiteSpace: 'nowrap',
            transform: 'translateY(30px)',
            opacity: 1,
            alignSelf: 'flex-end',
            marginRight: '-0.25em',

            '&$out': {
                transitionDuration: '0.5s',
                transitionDelay: '0',
                transform: 'translateY(-100px)',
                opacity: 0,
            },

            '&$in': {
                transform: 'translateY(0px)',
            },
        },

        out: {},
        in: {},
    },
    { name: 'AnimatedSpashTitle' }
);

const titleTop = `CONCEPTUALIZE`;
const titleBottom = `THIS`;

export default function AnimatedSplashTitle({ onComplete, state, setState }) {
    const classes = useStyles();

    useEffect(() => {
        setTimeout(() => setState('in'), 100);
        setTimeout(() => onComplete(), 3100);
    }, []);

    return (
        <div className={classes.wrap}>
            <h1 className={classes.splashTitle}>
                <span
                    className={classNames(
                        classes.titleTop,
                        state === 'out' && classes.out,
                        state === 'in' && classes.in
                    )}
                >
                    {titleTop.split('').map((letter, index) => {
                        const transitionDelayFill = Math.random() * 1500 + 200;
                        return (
                            <span key={index} className={classes.letter}>
                                <span
                                    className={classes.letterFill}
                                    style={{
                                        opacity: state === 'in' ? 1 : 0,
                                        transitionDelay:
                                            transitionDelayFill + 'ms',
                                    }}
                                >
                                    {letter}
                                </span>
                                <span
                                    aria-hidden="true"
                                    className={classes.letterOutline}
                                    style={{
                                        opacity: state === 'in' ? 0 : 1,
                                        transitionDelay:
                                            transitionDelayFill + 100 + 'ms',
                                    }}
                                >
                                    {letter}
                                </span>
                            </span>
                        );
                    })}
                </span>
                {/* <br /> */}
                <span
                    className={classNames(
                        classes.titleBottom,
                        state === 'out' && classes.out,
                        state === 'in' && classes.in
                    )}
                >
                    {titleBottom.split('').map((letter, index) => {
                        const transitionDelayFill = Math.random() * 1500 + 200;
                        return (
                            <span key={index} className={classes.letter}>
                                <span
                                    className={classes.letterFill}
                                    style={{
                                        opacity: state === 'in' ? 1 : 0,
                                        transitionDelay:
                                            transitionDelayFill + 'ms',
                                    }}
                                >
                                    {letter}
                                </span>
                                <span
                                    aria-hidden="true"
                                    className={classes.letterOutline}
                                    style={{
                                        opacity: state === 'in' ? 0 : 1,
                                        transitionDelay:
                                            transitionDelayFill + 100 + 'ms',
                                    }}
                                >
                                    {letter}
                                </span>
                            </span>
                        );
                    })}
                </span>
            </h1>
        </div>
    );
}
